import React, { useMemo } from 'react';
import cn from 'classnames';

import { Icon } from 'components';
import PlaceBetContext from '../../PlaceBetContext';
import { SinglePartMob } from '../BetslipFooter';
import Odd from '../Odd';
import useQuickBetslip from './useQuickBetslip';
import useValidQuickBetslipProps, {
    ValidQuickBetslipProps,
} from './useValidQuickBetslipProps';

import arrowLeft from 'assets/svg/arrow-left.svg';
import './quickBetslip.scss';

type QuickBetslipProps = ValidQuickBetslipProps;

const QuickBetslip: React.FC<QuickBetslipProps> = ({
    betslipOddId,
    betslipBetId,
    count,
    chosenBetslipBetId,
}) => {
    const { isOpen, toggleIsOpen, goToBetslip, title } = useQuickBetslip({
        count,
        betslipOddId,
        chosenBetslipBetId,
    });

    const button = useMemo(
        () => (
            <div styleName="button" onClick={goToBetslip}>
                {title}
            </div>
        ),
        [goToBetslip, title]
    );

    if (!isOpen || count > 1) return null;

    return (
        <div
            className="__app-QuickBetslip-container"
            styleName={cn('container', {
                'is-open': isOpen,
            })}
        >
            <div styleName="toggler" onClick={toggleIsOpen}>
                <Icon glyph={arrowLeft} styleName="icon" />
            </div>
            <div styleName="content">
                <div styleName="odd-wr">
                    <Odd
                        betslipOddId={betslipOddId}
                        isFirst={true}
                        isLast={true}
                    />
                </div>

                <PlaceBetContext.Provider value={goToBetslip}>
                    <SinglePartMob
                        betslipBetId={betslipBetId}
                        button={button}
                    />
                </PlaceBetContext.Provider>
            </div>
        </div>
    );
};

const QuickBetslipValidationProps: React.FC = () => {
    const validProps = useValidQuickBetslipProps();

    if (!validProps) return null;

    const {
        betslipOddId,
        betslipBetId,
        count,
        chosenBetslipBetId,
    } = validProps;

    return (
        <QuickBetslip
            betslipOddId={betslipOddId}
            betslipBetId={betslipBetId}
            count={count}
            chosenBetslipBetId={chosenBetslipBetId}
        />
    );
};

export default QuickBetslipValidationProps;
